var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import theme from '@adsk/alloy-react-theme';
import AlloyCheckbox from '@adsk/alloy-react-checkbox';
import { useLocale } from '@adsk/alloy-react-locale';
import { MAX_SELECTED_NODES } from '../../consts';
var FooterContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  position: static;\n  bottom: 0;\n  align-items: center;\n  padding: 12px 16px 12px;\n  border-top: 1px solid ", ";\n"], ["\n  display: flex;\n  justify-content: space-between;\n  position: static;\n  bottom: 0;\n  align-items: center;\n  padding: 12px 16px 12px;\n  border-top: 1px solid ", ";\n"])), theme.colors.charcoal200);
var Link = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  cursor: ", ";\n"], ["\n  ", "\n  color: ", ";\n  cursor: ", ";\n"])), __assign({}, theme.typography.bodySmallBold), function (_a) {
    var isDisabled = _a.isDisabled;
    return isDisabled ? theme.colors.charcoal500 : theme.colors.adskBlue700;
}, function (_a) {
    var isDisabled = _a.isDisabled;
    return (isDisabled ? 'default' : 'pointer');
});
Link.displayName = 'Link';
var Label = styled.label(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  display: flex;\n  line-height: 20px;\n"], ["\n  ", "\n  display: flex;\n  line-height: 20px;\n"])), __assign({}, theme.typography.bodySmall));
var IncludeSubItemsWrapper = styled(Label)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var SelectedNodesLabel = styled(Label)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), theme.colors.charcoal500);
SelectedNodesLabel.displayName = 'SelectedNodesLabel';
var Checkbox = styled(AlloyCheckbox)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-right: 8px;\n"], ["\n  margin-right: 8px;\n"])));
Checkbox.displayName = 'Checkbox';
export var CardFooter = function (_a) {
    var onClear = _a.onClear, includeSubItems = _a.includeSubItems, setIncludeSubItems = _a.setIncludeSubItems, selectedNodes = _a.selectedNodes, multiple = _a.multiple, _b = _a.clearable, clearable = _b === void 0 ? true : _b;
    var T = useLocale(function (_a) {
        var locale = _a.locale;
        return require("../i18n/".concat(locale, ".json"));
    }).T;
    var renderClear = function () { return (React.createElement(Link, { onClick: onClear, isDisabled: selectedNodes.length === 0 }, T.translate('cardFooter.clear'))); };
    var renderIncludeSubItems = function () {
        return !!setIncludeSubItems && (React.createElement(IncludeSubItemsWrapper, null,
            React.createElement(Checkbox, { checked: includeSubItems, onChange: function (val) { return setIncludeSubItems(val === true); } }),
            T.translate('cardFooter.includeSubItems')));
    };
    var renderSelectedNodes = function () { return (React.createElement(React.Fragment, null,
        React.createElement(SelectedNodesLabel, null, "".concat(selectedNodes.length, " ").concat(T.translate('cardFooter.selected')),
            selectedNodes.length >= MAX_SELECTED_NODES &&
                " (".concat(T.translate('cardFooter.max'), ")")),
        renderClear())); };
    if (multiple) {
        return (React.createElement(React.Fragment, null,
            setIncludeSubItems ? (React.createElement(FooterContainer, null, renderIncludeSubItems())) : null,
            React.createElement(FooterContainer, null, renderSelectedNodes())));
    }
    else {
        if (!setIncludeSubItems && !clearable) {
            return null;
        }
        return (React.createElement(FooterContainer, null,
            renderIncludeSubItems(),
            clearable && renderClear()));
    }
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
